import type { FunctionComponent } from 'react';
import React from 'react';

import { DynamicButton } from '@trello/dynamic-tokens';
import { forTemplate } from '@trello/i18n';
import { CalendarIcon } from '@trello/nachos/icons/calendar';
import { BoardHeaderTestIds } from '@trello/test-ids';

const format = forTemplate('board_header');

interface CalendarBoardButtonProps {
  onClick: () => void;
}

/* Legacy Calendar Powerup button hooked up to the BoardHeader */
export const CalendarBoardButton: FunctionComponent<CalendarBoardButtonProps> = ({
  onClick,
}) => {
  return (
    <div>
      <DynamicButton
        testId={BoardHeaderTestIds.CalendarPowerUp}
        style={{ margin: '0 4px 0 0' }}
        iconBefore={<CalendarIcon />}
        onClick={onClick}
      >
        {format('calendar')}
      </DynamicButton>
    </div>
  );
};
